import React, {useContext, useEffect, useRef, useState} from "react";
import {Context} from "../../../../App";
import {useTranslation} from "react-i18next";
import Input from "antd/es/input/Input";
import {Breadcrumb, Button, Dropdown, Menu, Space, Table, Tag} from "antd";
import {EyeInvisibleOutlined, EyeOutlined, MoreOutlined, PlusCircleOutlined, SearchOutlined} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {Link, Outlet, useNavigate} from "react-router-dom";
import DB_TradePointsCategory from "../../../../database/dictionary/trade-point-category";
import ModalWindow from "../../../modal";
import NextButton from "../../../tech/next_button";

const TradePointCategory = () => {
    const {token, user, setToken} = useContext(Context);
    const {getTradePointsCategories, statusTradePointsCategory} = DB_TradePointsCategory(token);
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const [data, setData] = useState()
    const [wait, setWait] = useState(true);


    const [pagination, setPagination] = useState({
        //current: 1,
        pageSize: 500,
        //total:200,
        showSizeChanger: false
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (confirm, setSelectedKeys) => {
        setSelectedKeys([]);
        confirm();
        setSearchText('');
        setSearchedColumn('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div
                style={{
                    padding: 8,
                }}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => handleReset(confirm, setSelectedKeys)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={
                        text ? text.toString() : ''
                    }/>
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: t('name'),
            dataIndex: 'name',
            ...getColumnSearchProps('name'),
        },
        {
            title: t('status'),
            dataIndex: 'status',
            filters: [
                {
                    text: t('active'),
                    value: 1
                },
                {
                    text: t('disable'),
                    value: 0
                }
            ],
            onFilter: (value, record) => {
                return record.status === value
            },
            render: (status) => (
                <>
                    <Tag color={status === 1 ? 'green' : 'volcano'} key={status}>
                        {status === 1 ? t('active') : t('disable')}
                    </Tag>
                </>
            ),
        },
        {
            title: '',
            render: (_, record) => (
                <div style={{display:'flex', justifyContent:'center'}}>
                    <Dropdown overlay={menu(record)}>
                        <Button icon={<MoreOutlined />} type={'text'}/>
                    </Dropdown>
                </div>
            ),
        },
        {
            title: "",
            width:'7%',
            render: (record) => {
                return(
                    <div className={'div-next-button'}>
                        <Link to={'category'} state={{id: record.id}}>
                            <NextButton/>
                        </Link>
                    </div>
                )
            }
        }
    ]

    useEffect(() => {
        window.scroll(0, 0)
        getTradePointsCategories()
            .then(res => {
                setData(res.data['data']);
                setPagination({
                    ...pagination,
                    total: res.data['all_count']
                })
                setWait(false);
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });
    }, [])

    const changeStatus =  (record) => {
        setWait(true)

        const formData = new FormData;
        formData.append('id', record.id);
        formData.append('status', (record.status ? 0 : 1));

        statusTradePointsCategory(formData)
            .then(res => {
                if (res.status === 200) {
                    const newData = data.map(n => {
                        if (n.id === record.id) {
                            return {...n, status: n.status === 0 ? 1 : 0}
                        }
                        return n
                    })
                    setData(newData)
                    setWait(false)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
            .finally(() => {
                setWait(false)
            })
    }

    const menu = (record) => (
        <Menu
            items={[
                {
                    label: (  <Button type={'text'} icon={record.status ? <EyeInvisibleOutlined/> :
                        <EyeOutlined/>} onClick={() => changeStatus(record)}>{t('change_status')}</Button>),
                    key: '2',
                }
            ]}
        />
    );

    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('trade_points_categories')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <Link key='1' to="category" state={{id: null}}>
                            <Button type={'primary'} shape={'round'} icon={<PlusCircleOutlined/>}>{t('add')}</Button>
                        </Link>
                    </Space>
                </Space>


                <Table
                    style={{'--cursor': "auto" }}
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    loading={wait}
                    pagination={pagination}
                    size={"small"}
                />


            </div>
            <Outlet/>
        </>
    )
}

export default TradePointCategory;